/**
 * components/toast.ts
 * Notificações toast usando Bootstrap 5.
 */

type ToastType = 'success' | 'danger' | 'info' | 'warning';

const icons: Record<ToastType, string> = {
    success: '✓',
    danger:  '✗',
    info:    'ℹ',
    warning: '⚠',
};

const labels: Record<ToastType, string> = {
    success: 'Sucesso',
    danger:  'Erro',
    info:    'Informação',
    warning: 'Atenção',
};

function getOrCreateContainer(): HTMLElement {
    let container = document.getElementById('toast-container');
    if (!container) {
        container = document.createElement('div');
        container.id = 'toast-container';
        container.className = 'toast-container position-fixed bottom-0 end-0 p-3';
        container.style.zIndex = '9999';
        document.body.appendChild(container);
    }
    return container;
}

function show(message: string, type: ToastType): void {
    const container = getOrCreateContainer();

    const el = document.createElement('div');
    el.className = `toast align-items-center text-bg-${type} border-0`;
    el.setAttribute('role', 'alert');
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('aria-atomic', 'true');
    el.innerHTML = `
        <div class="d-flex">
            <div class="toast-body d-flex align-items-center gap-2">
                <span>${icons[type]}</span>
                <span>${message}</span>
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto"
                    data-bs-dismiss="toast" aria-label="Fechar"></button>
        </div>`;

    container.appendChild(el);

    const bsToast = new (window as any).bootstrap.Toast(el, { delay: 4500 });
    bsToast.show();

    el.addEventListener('hidden.bs.toast', () => el.remove());
}

const Toast = {
    success: (message: string) => show(message, 'success'),
    error:   (message: string) => show(message, 'danger'),
    info:    (message: string) => show(message, 'info'),
    warning: (message: string) => show(message, 'warning'),
};

export default Toast;
